var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 51,
    viewBox: "0 0 121 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 50.4785H13.9688V0H16.125V50.4785ZM2.65527 44.1914H0.5V8.44238H2.65527V44.1914ZM29.6094 39.5215H27.4541V12.9346H29.6094V39.5215ZM43.0781 25.3301H52.2881V17.6504H54.3926V34.8965H52.2881V27.1826H43.0781V34.8496H43.0244V34.8965H40.9199V17.6504H40.9229V17.6045H43.0781V25.3301ZM76.1709 19.5029H67.8076V25.3301H75.6289V27.1826H67.8076V33.0439H76.3066V34.8965H65.708V17.6504H76.1709V19.5029ZM100.567 34.8965H98.3652L96.6211 30.0117H89.6045L87.8604 34.8965H85.6582L92.0283 17.6504H94.1973L100.567 34.8965ZM112.521 33.0439H120.502V34.8965H110.442V17.6504H112.521V33.0439ZM90.2666 28.1592H95.959L93.1807 20.3789H93.0449L90.2666 28.1592Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.830f85264de253ec91df41ed3e28f6ab.svg";
export { ForwardRef as ReactComponent };